/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Check esistenza file allegati per id allegato cfg
 * @summary Check esistenza file allegati per id allegato cfg
 */
export const getBackFileAllegatiExistsbyallegatoId = (
  idAllegatoCfg: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<boolean>(
    {
      url: `/framework-bo-procedimenti/file-allegati/existsbyallegato/${idAllegatoCfg}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackFileAllegatiExistsbyallegatoIdQueryKey = (
  idAllegatoCfg: string,
) =>
  [
    `/framework-bo-procedimenti/file-allegati/existsbyallegato/${idAllegatoCfg}`,
  ] as const;

export const getGetBackFileAllegatiExistsbyallegatoIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>,
  TError = ErrorType<unknown>,
>(
  idAllegatoCfg: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackFileAllegatiExistsbyallegatoIdQueryKey(idAllegatoCfg);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>
  > = ({ signal }) =>
    getBackFileAllegatiExistsbyallegatoId(
      idAllegatoCfg,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!idAllegatoCfg, ...queryOptions };
};

export type GetBackFileAllegatiExistsbyallegatoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>
>;
export type GetBackFileAllegatiExistsbyallegatoIdQueryError =
  ErrorType<unknown>;

/**
 * @summary Check esistenza file allegati per id allegato cfg
 */
export const useGetBackFileAllegatiExistsbyallegatoId = <
  TData = Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>,
  TError = ErrorType<unknown>,
>(
  idAllegatoCfg: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackFileAllegatiExistsbyallegatoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackFileAllegatiExistsbyallegatoIdQueryOptions(
    idAllegatoCfg,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
